import React, { Fragment } from "react";
import Loading from "../../../../../components/Loading";
import { Collapse, Icon } from "antd";
import { numberToReal } from "../../../../../helpers/functions";

import "../../../../../styles/css/print.css";

const Panel = Collapse.Panel;

const icmsModule = sessionStorage.getItem("icmsModule");

const getTotal = (total, changeText) => (
  <span>
    {changeText ? "Valor informado:" : "Valor Total:"} {total}
  </span>
);

function getBreakPipe(item, portion) {
  if (item !== null && item !== undefined && item !== "") {
    if (portion === 0) {
      return item
        .split("|")
        .map((item, index) => <span key={Math.random()}>{item}</span>);
    } else {
      return item
        .split("|")
        .map((item, index) => (
          <span key={Math.random()}>
            {!index ? `Parcela ${portion} = ${item}` : item}
          </span>
        ));
    }
  } else {
    return null;
  }
}

function handleTextColumn(item, field) {
  if (field === "cofins" || field === "pis") {
    switch (item.Status) {
      case 5:
      case 6:
        return "Substituição Tributária";
      case 2:
      case 4:
        return "Tributação Monofásica";
      default:
        return;
    }
  }

  if (field === "icms") {
    switch (item.Status) {
      case 2:
      case 3:
      case 6:
        return "Substituição Tributária";
      default:
        return;
    }
  }
}

function renderRows1(data) {
  return data.map((item) => {
    return item.Status === 1 ? (
      <Fragment key={item.Id}>
        <tr>
          <td className="pt-3" colSpan="9">
            {getBreakPipe(item.Descritivos, 0)}
          </td>
        </tr>
        <tr>
          <td>IRPJ</td>
          <td>CSLL</td>
          <td className={!item.COFINS ? "col-empty" : null}>COFINS</td>
          <td className={!item.PIS ? "col-empty" : null}>PIS/Pasep</td>
          <td>INSS/CPP</td>
          <td>ICMS</td>
          <td>IPI</td>
          <td>ISS</td>
          <td>Total</td>
        </tr>
        <tr>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className={!item.COFINS ? "col-empty" : null}>
            {numberToReal(item.COFINS)}
          </td>
          <td className={!item.PIS ? "col-empty" : null}>
            {numberToReal(item.PIS)}
          </td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td>{numberToReal(item.ICMS)}</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
        </tr>
      </Fragment>
    ) : null;
  });
}

function renderRows2(data) {
  let portion = 0;
  return data.map((item) => {
    return (item.Status >= 2 && item.Status <= 6) ||
      (item.Status >= 12 && item.Status <= 14) ? (
      <Fragment key={item.Id}>
        <tr>
          <td className="pt-3" colSpan="9">
            {getBreakPipe(item.Descritivos, (portion += 1))}
          </td>
        </tr>
        <tr>
          <td>IRPJ</td>
          <td>CSLL</td>
          <td className={!item.COFINS && item.Status <= 6 ? "col-empty" : null}>
            COFINS
          </td>
          <td className={!item.PIS && item.Status <= 6 ? "col-empty" : null}>
            PIS/Pasep
          </td>
          <td>INSS/CPP</td>
          <td className={!item.ICMS && item.Status <= 6 ? "col-empty" : null}>
            ICMS
          </td>
          <td>IPI</td>
          <td>ISS</td>
          <td>Total</td>
        </tr>
        <tr>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className={!item.COFINS && item.Status <= 6 ? "col-empty" : null}>
            {!item.COFINS && item.Status <= 6
              ? handleTextColumn(item, "cofins")
              : numberToReal(item.COFINS)}
          </td>
          <td className={!item.PIS && item.Status <= 6 ? "col-empty" : null}>
            {!item.PIS && item.Status <= 6
              ? handleTextColumn(item, "pis")
              : numberToReal(item.PIS)}
          </td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className={!item.ICMS && item.Status <= 6 ? "col-empty" : null}>
            {!item.ICMS && item.Status <= 6
              ? handleTextColumn(item, "icms")
              : numberToReal(item.ICMS)}
          </td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
        </tr>
      </Fragment>
    ) : null;
  });
}

function renderSubRows2(data) {
  return data.map((item) => {
    return item.Status === 7 ? (
      <Fragment key={item.Id}>
        <tr>
          <th className="pt-3" colSpan="9">
            Total devido por tributo (R$)
          </th>
        </tr>
        <tr>
          <td>IRPJ</td>
          <td>CSLL</td>
          <td>COFINS</td>
          <td>PIS/Pasep</td>
          <td>INSS/CPP</td>
          <td>ICMS</td>
          <td>IPI</td>
          <td>ISS</td>
          <td>Total</td>
        </tr>
        <tr>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td>{numberToReal(item.COFINS)}</td>
          <td>{numberToReal(item.PIS)}</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td>{numberToReal(item.ICMS)}</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
          <td className="col-info">Valor a ser calculado pelo PGDAS-D</td>
        </tr>
      </Fragment>
    ) : null;
  });
}

function renderRows3(data) {
  return data.map((item) => {
    return item.Status === 8 ? (
      <Fragment key={item.Id}>
        <tr>
          <th className="text-left" colSpan="9">
            Total devido por tributo (R$)
          </th>
        </tr>
        <tr>
          <td>IRPJ</td>
          <td>CSLL</td>
          <td>COFINS</td>
          <td>PIS/Pasep</td>
          <td>INSS/CPP</td>
          <td>ICMS</td>
          <td>IPI</td>
          <td>ISS</td>
          <td>Total</td>
        </tr>
        <tr>
          <td>{numberToReal(item.IRPJ)}</td>
          <td>{numberToReal(item.CSLL)}</td>
          <td>{numberToReal(item.COFINS)}</td>
          <td>{numberToReal(item.PIS)}</td>
          <td>{numberToReal(item.INSS)}</td>
          <td>{numberToReal(item.ICMS)}</td>
          <td>{numberToReal(item.IPI)}</td>
          <td>{numberToReal(item.ISS)}</td>
          <td>{numberToReal(item.Total)}</td>
        </tr>
      </Fragment>
    ) : null;
  });
}

function renderRows4(data) {
  return data.map((item) => {
    return item.Status === 9 ? (
      <Fragment key={item.Id}>
        <tr>
          <td>IRPJ</td>
          <td>CSLL</td>
          <td>COFINS</td>
          <td>PIS/Pasep</td>
          <td>INSS/CPP</td>
          <td>ICMS</td>
          <td>IPI</td>
          <td>ISS</td>
          <td>Total</td>
        </tr>
        <tr>
          <td>{numberToReal(item.IRPJ)}</td>
          <td>{numberToReal(item.CSLL)}</td>
          <td>{numberToReal(item.COFINS)}</td>
          <td>{numberToReal(item.PIS)}</td>
          <td>{numberToReal(item.INSS)}</td>
          <td>{numberToReal(item.ICMS)}</td>
          <td>{numberToReal(item.IPI)}</td>
          <td>{numberToReal(item.ISS)}</td>
          <td>{numberToReal(item.Total)}</td>
        </tr>
      </Fragment>
    ) : null;
  });
}

function renderRows5(data) {
  return data.map((item) => {
    return item.Status === 10 ? (
      <Fragment key={item.Id}>
        <tr>
          <td>IRPJ</td>
          <td>CSLL</td>
          <td>COFINS</td>
          <td>PIS/Pasep</td>
          <td>INSS/CPP</td>
          <td>ICMS</td>
          <td>IPI</td>
          <td>ISS</td>
          <td>Total</td>
        </tr>
        <tr>
          <td>{numberToReal(item.IRPJ)}</td>
          <td>{numberToReal(item.CSLL)}</td>
          <td>{numberToReal(item.COFINS)}</td>
          <td>{numberToReal(item.PIS)}</td>
          <td>{numberToReal(item.INSS)}</td>
          <td>{numberToReal(item.ICMS)}</td>
          <td>{numberToReal(item.IPI)}</td>
          <td>{numberToReal(item.ISS)}</td>
          <td>{numberToReal(item.Total)}</td>
        </tr>
      </Fragment>
    ) : null;
  });
}

function visibleRow2(data) {
  return data.filter((item) => {
    if (
      (item.Status >= 2 && item.Status <= 6) ||
      (item.Status >= 12 && item.Status <= 14)
    )
      return true;
    else return false;
  });
}

const TableSynthetic = (props) => {
  const { tributosResultadoPisCofins, resultadoPisCofins } = props.data;
  const { plots } = props;
  const newTaxes = tributosResultadoPisCofins.sort((a, b) =>
    a.Status > b.Status ? 1 : b.Status > a.Status ? -1 : 0
  );

  return (
    <>
      {!tributosResultadoPisCofins ? <Loading /> : null}

      <h3 className="segregation__title">
        Segregação das receitas de acordo com a auditoria
      </h3>

      {!!resultadoPisCofins.ValorAdicionadoTributado && (
        <div className="segregation__info">
          <span>
            {`Valor ajustado: ${numberToReal(
              resultadoPisCofins.ValorAdicionadoTributado
            )}`}
          </span>

          <span>
            {` ${
              resultadoPisCofins.SimplesNacional?.ImpedidoRecolherICMS ? "Impedido de recolher ICMS/ISS no DAS: Sim" : ""
            }`}
          </span>
        </div>
      )}

      {!!resultadoPisCofins.ValorAdicionadoMonofasico && (
        <div className="segregation__info">
          <span>
            {`Valor ajustado: ${numberToReal(
              resultadoPisCofins.ValorAdicionadoMonofasico
            )}`}
          </span>
        </div>
      )}

      <Collapse
        className="ant-collapse--custom"
        bordered={false}
        defaultActiveKey={["1", "2", "3", "4", "5", "6"]}
        expandIcon={({ isActive }) => (
          <Icon type="caret-right" rotate={isActive ? 90 : 0} />
        )}
      >
        {plots.totalStatus1 && newTaxes.some((x) => x.Status === 1) ? (
          <Panel
            header="Atividade: Revenda de mercadorias, exceto para o exterior - Sem
                substituição tributária/tributação monofásica/antecipação com
                encerramento de tributação (o substituto tributário do ICMS deve
                utilizar essa opção)"
            key="1"
            extra={getTotal(plots.totalStatus1, false)}
          >
            <table className="table table-sm table-bordered">
              <tbody>{renderRows1(newTaxes)}</tbody>
            </table>
          </Panel>
        ) : null}

        <Panel
          header="Atividade: Revenda de mercadorias, exceto para o exterior - Com
        substituição tributária/tributação monofásica/antecipação com
        encerramento de tributação (o substituído tributário do ICMS
        deve utilizar essa opção)"
          key="2"
          className={!visibleRow2(newTaxes).length ? "d-none" : null}
          extra={getTotal(plots.totalStatus7, false)}
        >
          <table className="table table-sm table-bordered">
            <tbody>
              {renderRows2(newTaxes)}
              {renderSubRows2(newTaxes)}
            </tbody>
          </table>
        </Panel>

        {plots.totalStatus10 ? (
          <Panel
            header="Outras Receitas"
            key="4"
            extra={getTotal(plots.totalStatus10, false)}
          >
            <table className="table table-sm table-bordered">
              <tbody>{renderRows5(newTaxes)}</tbody>
            </table>
          </Panel>
        ) : null}

        <Panel
          header="Totais do estabelecimento"
          key="5"
          extra={getTotal(plots.totalStatus8, false)}
        >
          <table className="table table-sm table-bordered">
            <tbody>{renderRows3(newTaxes)}</tbody>
          </table>
        </Panel>

        <Panel
          header="Receita total informada"
          key="6"
          extra={getTotal(plots.totalStatus9, true)}
        >
          <table className="table table-sm table-bordered">
            <tbody>{renderRows4(newTaxes)}</tbody>
          </table>
        </Panel>
      </Collapse>

      <div
        className={`segregation__total mb-2 ${
          resultadoPisCofins.ValorCreditoRecuperar > 0
            ? "segregation__total--success"
            : resultadoPisCofins.ValorCreditoRecuperar < 0
            ? "segregation__total--danger"
            : "segregation__total--warning"
        }`}
      >
        <h5 className="segregation__total___title">
          Total de crédito a recuperar de PIS/COFINS:
        </h5>
        <span className="segregation__total___value">
          {numberToReal(resultadoPisCofins.ValorCreditoRecuperar)}
        </span>
      </div>
      {icmsModule ? (
        <div
          className={`segregation__total ${
            resultadoPisCofins.ValorCreditoRecuperarIcms > 0
              ? "segregation__total--success"
              : resultadoPisCofins.ValorCreditoRecuperarIcms < 0
              ? "segregation__total--danger"
              : "segregation__total--warning"
          }`}
        >
          <h5 className="segregation__total___title">
            Total de crédito a recuperar de ICMS:
          </h5>
          <span className="segregation__total___value">
            {numberToReal(resultadoPisCofins.ValorCreditoRecuperarIcms)}
          </span>
        </div>
      ) : null}
    </>
  );
};

export default TableSynthetic;
